module.exports = __webpack_public_path__ + "img/Terms of Service2.14a898a6.jpg";